import { useEffect, useRef } from 'react';

export default function useIdleLogout(timeout, onIdle) {
  const timerRef = useRef();

  useEffect(() => {
    if (!timeout) return; // skip if not logged in

    const resetTimer = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(onIdle, timeout);
    };

    const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, [timeout]);
}